import { IApplicationState } from '../../types/redux';

export function selectNewbuildingBlackFriday(state: IApplicationState) {
  return state.dropdown.newbuildingBlackFriday;
}
